import {
  PurchaseFreightBookingRequestSchema,
  PurchaseFreightBookingResponseSchema,
} from "@redotech/redo-fulfillment-operations-common/freight/freight-booking";

export const purchaseFreightBooking = {
  name: "purchaseFreightBooking" as const,
  input: PurchaseFreightBookingRequestSchema,
  output: PurchaseFreightBookingResponseSchema,
};
